export const getTierColor = (tierLevel: number) => {
  switch (tierLevel) {
    case 1: return '#ff4d4f'; // Free
    case 2: return '#43c37b'; // Starter (darker green pastel)
    case 3: return '#af85ff'; // Teams
    case 4: return '#4e3eff'; // Business
    default: return '';
  }
};